/**
 * Sanity Severity Constants
 */

export const SEVERITY = {
    OK: "ok",
    WARNING: "warning",
    CRITICAL: "critical",
} as const;
